import { environment } from "environments/environment";

export function build(segments: string[], action: string): string {
  return `${environment.urls.api}/${segments.join('/')}/${action}`;
}

export function PaymentApibuild(segments: string[], action: string): string {
  return `${environment.urls.apiPayments}/${segments.join('/')}/${action}`;
}
